import { Select, MenuItem } from '@mui/material';

// Custom input component that excludes blank option
const CustomSingleSelectInput = ({ item, applyValue, apiRef, ...props }) => {
  const handleChange = (event) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ''}
      onChange={handleChange}
      size="small"
      sx={{ minWidth: 170 }}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) {
          return <span style={{ color: '#999' }}>Select</span>;
        }
        return selected;
      }}
      {...props}
    >
      {props.options?.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};

// Reusable filter operators to remove blank option from singleSelect
export const getCustomSingleSelectOperators = (options) => [
  {
    value: 'is',
    label: 'Is',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value || filterItem.value === '') {
        return null;
      }
      return ({ value }) => {
        return value === filterItem.value;
      };
    },
    InputComponent: CustomSingleSelectInput,
    InputComponentProps: { 
      options: options
    },
  },
  {
    value: 'not',
    label: 'Is not',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value || filterItem.value === '') {
        return null;
      }
      return ({ value }) => {
        return value !== filterItem.value;
      };
    },
    InputComponent: CustomSingleSelectInput,
    InputComponentProps: { 
      options: options
    },
  },
  {
    value: 'isAnyOf',
    label: 'Is any of',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value || filterItem.value === '') {
        return null;
      }
      return ({ value }) => {
        return value.includes(filterItem.value);
      };
    },
    InputComponent: CustomSingleSelectInput,
    InputComponentProps: { 
      options: options
    },
  },
  
];

// Helper function to create a singleSelect column with custom filter operators
export const createSingleSelectColumn = (field, headerName, options, additionalProps = {}) => {
  return {
    field,
    headerName,
    type: 'singleSelect',
    valueOptions: options,
    filterOperators: getCustomSingleSelectOperators(options),
    ...additionalProps,
  };
};

// Helper function to create a singleSelect column with default styling
export const createStyledSingleSelectColumn = (field, headerName, options, additionalProps = {}) => {
  return createSingleSelectColumn(field, headerName, options, {
    minWidth: 130,
    maxWidth: 200,
    flex: 1,
    ...additionalProps,
  });
};

// Helper function to create a singleSelect column with default styling
